<template>
  <div class="AdvisoryCenter">
    <!--头部banner-->
    <div class="banner"></div>

    <!--主体-->
    <div class="main m-b-30">
      <div class="elbox">
        <el-row>
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="left">
                <div class="content">
                  <div class="AdvisoryCenter">资讯中心</div>
                  <div class="menu">
                    <el-menu :default-openeds="getopenList" :default-active="activeItem" class="el-menu-vertical-demo" @select="handleSelect" @open="handleOpen" @close="handleClose">
                      <div v-for="(father,i) in menu" :key="i">
                        <el-submenu v-if="father.menuson" :index="father.index">
                          <template slot="title">
                            <i :class="father.icon"></i>
                            <span>{{ father.name }}</span>
                          </template>
                          <el-menu-item v-for="(item,i) in father.menuson" :key="i" :index="item.index">
                            <span slot="title">{{ item.name }}</span>
                          </el-menu-item>
                        </el-submenu>

                        <el-menu-item v-else :index="father.index">
                          <i :class="father.icon"></i>
                          <span slot="title">{{ father.name }}</span>
                        </el-menu-item>
                      </div>
                    </el-menu>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="18">
            <div class="grid-content bg-purple-light">
              <div class="right">
                <div class="content">
                  <div class="Bread_crumbs">
                    <el-breadcrumb separator="/">
                      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                      <el-breadcrumb-item :to="{ path: '/AdvisoryCenter' }">资讯中心</el-breadcrumb-item>
                      <el-breadcrumb-item>{{ getcurrentitem }}</el-breadcrumb-item>
                    </el-breadcrumb>
                  </div>

                  <div v-if="!isShow">
                    <div class="title">{{ getcurrentitem }}</div>

                    <!--表格-->
                    <div class="Table">
                      <el-table @cell-mouse-enter="mouseEnter" @cell-mouse-leave="mouseLeave" @row-click="handleTableRow" :data="tableData" :max-height="550" style="width: 100%">
                        <el-table-column  type="index" label="序号" :index="indexMethod" width="50"></el-table-column>
                        <el-table-column v-for="(item,index) in getTableType" :key="index" :prop="item.prop" :width="index === getTableType.length - 1 ? 200 : ''" :label="item.label">
                          <template v-if="item.prop === 'status'" v-slot="{row,$index}">
                            <template><div :style="{color: (row.status === 0 || row.status)? MerchantStatus[row.status].color : 'white'}">{{(row.status === 0 || row.status) ? MerchantStatus[row.status].typeName : ''}}</div></template>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>

                    <!--分页-->
                    <div class="block">
                      <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
                      </el-pagination>
                    </div>
                  </div>
                  <div v-else class="showBox">
                    <div class="title_">{{ contentData.title }}</div>
                    <div class="date_">发布时间：{{ contentData.createTime }}</div>
                    <div v-html="contentData.content" class="info"></div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>

  import {getShopId} from "@/const/AdvisoryCenter";

  export default {
    name: 'AdvisoryCenter',
    components: {},
    data() {
      return {
        MerchantStatus: {
          0: {
            typeName: '待审核',
            color: '#909399'
          },
          1: {
            typeName: '审核通过',
            color: '#67C23A'
          },
          2: {
            typeName: '审核不通过',
            color: '#F56C6C'
          },
          3: {
            typeName: '冻结',
            color: '#409EFF'
          }
        },

        contentData: '',
        isShow: false,

        form: {
          "dataIsPublish": 1,
          "informationCategoryId": "",
          "orderType": 1,
          "pageNum": 0,
          "pageSize": 0,
        },

        pageNum: 1,
        total: 10,
        pageSize: 10,

        Review_business_activity_tableType: [{ label: '商家名称', prop: 'name' }, { label: '申请时间', prop: 'applyTime' }, { label: '申请状态', prop: 'status' }],
        defaultTableconfig: [{ label: '标题', prop: 'title' }, { label: '发布时间', prop: 'createTime' }],

        tableData: [],

        itemobj: {
          Review_business_activity: '审核商家动态',
          GKFXYL: '公开发行一览',
          ZCFG: '政策法规',
          KJJT: '科技讲堂',
          XWGG: '新闻公告'
        },

        menu: [{
            index: 'Review_business_activity',
            name: '审核商家动态',
            icon: 'el-icon-s-shop'
          },
          {
            index: 'GKFXYL',
            name: '公开发行一览',
            icon: 'el-icon-s-opportunity',
          },
          {
            index: 'ZCFG',
            name: '政策法规',
            icon: 'el-icon-s-comment',
          },
          {
            index: 'KJJT',
            name: '科技讲堂',
            icon: 'el-icon-school'
          },
          {
            index: 'XWGG',
            name: '新闻公告',
            icon: 'el-icon-postcard',
          }
        ],

        scroll: '',

        //默认展开
        // open_list: ['PoliciesAndRegulations'],
        info: {},
        activeItem: 'Review_business_activity',
        msgInfo: {}
      };
    },
    computed: {
      getopenList() {
        return this.open_list ? this.open_list : []
      },
      getcurrentitem() {
        return this.itemobj[this.$route.query.type] ? this.itemobj[this.$route.query.type] : this.itemobj.InvestmentRules
      },
        getTableType() {
        if(this.$route.query.type === 'Review_business_activity') {
          return this[this.$route.query.type + '_tableType']
        }else {
          return this.defaultTableconfig
        }

      }
    },
    created() {
    },
    mounted() {
      //添加滚动监听器
      window.addEventListener('scroll', this.handleScroll)
    },

    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    watch: {
      '$route.query.type': {
        immediate: true,
        handler(newValue) {
          if (newValue) {
            if (Object.keys(this.itemobj).includes(newValue)) {
              this.activeItem = newValue;
              if (newValue == 'Review_business_activity') {
                this.getReview_business_activity()
              }else {
                this.getInfo(this.activeItem)
              }
            } else {
              this.redirectRoute()
            }
          } else {
            this.redirectRoute()
          }
        }
      },
      $route(newValue, oldValue) {
        this.isShow = false
        this.$nextTick(() => { //路由发生变化，使用监听到的滚动位置
          document.body.scrollTop = this.scroll;
          document.documentElement.scrollTop = this.scroll;
        })
      }
    },
    methods: {
      //获取信息
      async getInfo(type) {
        try {
          let res = await this.$http.get(this.$const.Platformconsulting.GetInformatioCategoryn + type)
          if (res.code === 200) {
            let {pageNum, pageSize} = this
            let params = JSON.parse(JSON.stringify(this.form))
            Object.assign(params, {pageNum, pageSize, informationCategoryId: res.data.id})

            let info = await this.$http.post(this.$const.Platformconsulting.GetInformatio, params)
            if (info.code === 200) {
              this.total = info.data.total
              this.tableData = info.data.list
            }
          }

        } catch (e) {
          console.log(e);
        }
      },


      //
      getReview_business_activity() {
        let parms = {
          "endTime": "",
          "name": "",
          "pageNum": this.pageNum,
          "pageSize": this.pageSize,
          "startTime": "",
          "type": ''
        }
        this.$http.post(this.$const.AdvisoryCenter.supplierPage, parms, true).then((res) => {
          if (res.data) {
            this.tableData = res.data.list;
            // this.tableData = this.tableData.filter(item => item.status === 1)
            // this.total = this.tableData.length;
            this.total = res.data.total
            // this.tableData = this[this.$route.query.type + '_tableData']
          }
        }).catch((error) => {
          console.log(error, 'error')
        });
      },
      mouseEnter(row, column, cell, event) {
        if (column.property === 'title') {
          cell.style.color = '#3868e9'
        }
      },
      mouseLeave(row, column, cell, event) {
        if (column.property === 'title') {
          cell.style.color = 'black'
        }
      },

      async handleTableRow(row, event, column) {
        if (this.$route.query.type !== 'Review_business_activity') {
          this.isShow = true
          console.log(row, '|', event, '|', column)

          try {
            let res = await this.$http.get(this.$const.Platformconsulting.GetNewsInfo + row.id)
            if (res.code === 200) {
              this.newsInfo = JSON.parse(JSON.stringify(res.data))
              this.contentData = res.data
            }
          }catch (e) {
            console.log(e);
          }
        }else {
          if (row.status === 1) { //审核通过



            this.$http.get(this.$const.AdvisoryCenter.getShopId + row.id).then((res) => {
              if (res.code === 200) {
                let routeUrl = this.$router.resolve({
                  name: "companyInfo",
                  query: {
                    shopId: res.data.id,
                    supplierId: row.id,
                  }
                });
                window.open(routeUrl.href, '_blank');
              }
            }).catch((error) => {
              console.log(error, 'error')
            });
          }else {
            this.$message.warning('审核未通过不支持查看')
          }
        }
      },

      handleCurrentChange(pageNum) {
        console.log(`当前页: ${pageNum}`);
        this.pageNum = pageNum
        this.getReview_business_activity()
      },

      redirectRoute() {
        this.$router.push({
          name: 'AdvisoryCenter',
          query: {
            type: 'Review_business_activity'
          }
        })
      },

      handleScroll() {
        this.scroll = document.documentElement.scrollTop || document.body.scrollTop
      },

      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },
      handleSelect(key, keyPath) {
        this.isShow = false
        this.$router.push({
          name: 'AdvisoryCenter',
          query: {
            type: keyPath[keyPath.length - 1]
          }
        })
      },
      // 表格序号
      indexMethod(index) {
        return (this.pageNum - 1) * this.pageSize + index + 1;
      }
    },
  };
</script>

<style lang="scss" scoped>
  $height: 710px;

  /deep/ tbody tr.el-table__row {
    cursor: pointer;
  }

  .AdvisoryCenter {
    .banner {
      width: 100%;
      min-width: 1200px;
      height: 25vh;
      background: url('~@/assets/imgs/AdvisoryCenter/lunar _rover_banner.png') no-repeat;
      background-size: 100% 100%;
      background-position: center;
    }

    .main {
      // margin-top: -50px;

      .elbox {
        margin: 0 auto;
        width: 100%;

        .left {
          width: 100%;
          padding: 0 0 0 50px;

          .content {
            width: 100%;
            height: $height;
            background: #fff;
            border: 1px solid #dde4ea;

            .menu {
              height: calc(100% - 50px);
              overflow-y: auto;
              scrollbar-width: none;
              /* firefox */
              -ms-overflow-style: none;

              /* IE 10+ */
              &::-webkit-scrollbar {
                /* Chrome Safari */
                display: none
              }
            }

            .el-menu {
              border-right: none;

              li.el-menu-item.is-active::before {
                display: inline-block;
                content: '';
                width: 5px;
                height: 15px;
                background: #3867e9;
                position: absolute;
                top: 0;
                bottom: 0;
                margin: auto;
                left: 0;
              }
            }

            .AdvisoryCenter {
              padding-left: 40px;
              height: 50px;
              line-height: 50px;
              font-size: 20px;
              font-weight: bold;
            }

            ul.AdvisoryCenter_item {
              overflow: hidden;
            }
          }
        }

        .right {
          width: 100%;
          padding: 0 50px 0 20px;

          .content {
            width: 100%;
            height: $height;
            background: #fff;
            margin: 0 auto;
            border: 1px solid #dde4ea;
            padding: 25px 25px 0 25px;

            .Bread_crumbs {
              margin-bottom: 10px;
              height: 30px;
              border-bottom: 1px solid #e4e9ee;
            }

            .title {
              margin-bottom: 10px;
            }

            .Table {
              height: 528px;
            }

            .block {
              text-align: end;
              margin-top: 35px;
            }

            .showBox {
              height: 635px;
              overflow-y: auto;
              scrollbar-width: none;
              /* firefox */
              -ms-overflow-style: none;
              /* IE 10+ */

              &::-webkit-scrollbar {
                /* Chrome Safari */
                display: none
              }

              .title_ {
                //height: 70px;
                line-height: 60px;
                font-size: 27px;
                text-align: center;
                padding: 10px 0;
              }

              .date_ {
                height: 25px;
                line-height: 25px;
                text-align: center;
                font-size: 14px;
              }

              .info {
                padding: 20px;
              }
            }
          }
        }
      }
    }

  }
</style>
